import { useQuery } from "react-query";
import * as summariesService from "api/services/summaryService";

/**
 * Store server's state of project results
 *
 * @param {summariesService.SummaryPayload} payload The summary request payload of the project results being fetched
 *
 * @returns The query object returned by the useQuery hook
 */
export const useProjectsResultsData = (payload) =>
  useQuery(
    ["projectResults", payload],
    () => summariesService.getProjectResults(payload),
    {
      select: ({ data }) => data,
      enabled: !!Object.keys(payload)?.length,
      refetchOnWindowFocus: false,
      retry: false,
    }
  );
